app.ContactHr = (
    function () {
        var contact = {
            Init: function () {
                app.ContactHr.InitContactFlag();

                // Reinitialize on grid reload
                $(document).on("component-filter-grid-complete", function () {
                    app.ContactHr.InitContactFlag();
                });
            },
            InitContactFlag: function () {
                // Bind click and keyboard interaction to the flag
                $(document).on('click keydown', '.fa-flag', function (e) {
                    // Allow interaction via "Enter" or "Space" keys (in addition to clicks)
                    if (e.type === 'keydown' && !(e.key === 'Enter' || e.key === ' ')) {
                        return;
                    }

                    e.preventDefault(); // Prevent default behavior for space/enter keys

                    const $icon = $(this);
                    const applicationId = $icon.data('application-id');

                    if (!applicationId) {
                        console.error("No applicationId found for Contact HR toggle.");
                        toastr.error("Could not update Contact HR status. No valid application identifier found.");
                        return;
                    }

                    // Find all elements on the page with the same application ID
                    const $allMatchingFlags = $(`[data-application-id='${applicationId}']`);
                    const currentStatus = $allMatchingFlags.closest('.red-flag, .default-flag').hasClass('red-flag');

                    // Prepare the data payload
                    const payload = { applicationId: applicationId };

                    // Send the request to the server
                    $.post('/Employer/Home/ContactHr', payload)
                        .done(function (data) {
                            if (!Array.isArray(data) || data.length === 0) {
                                toastr.error("Failed to update Contact HR status. Please try again.");
                            }

                            // Iterate over all returned application IDs and update the flags
                            data.forEach(function (appId) {
                                const $matchingFlags = $(`[data-application-id='${appId}']`);

                                if ($matchingFlags.length) {
                                    $matchingFlags.each(function () {
                                        const $flagWrapper = $(this).closest('.red-flag, .default-flag');
                                        const $icon = $(this);
                                        const $contactHrText = $(this).closest(".row").find('.contact-hr-text');

                                        // Toggle the class
                                        $flagWrapper
                                            .toggleClass('red-flag', !currentStatus)
                                            .toggleClass('default-flag', currentStatus);

                                        // Update ARIA label
                                        $icon.attr('aria-label', !currentStatus ? 'No Need to Contact HR' : 'Contact HR button');

                                        // Show/hide the "Contact HR" text
                                        if (!currentStatus) {
                                            $contactHrText.show();
                                        } else {
                                            $contactHrText.hide();
                                        }
                                    });
                                }
                            });

                            toastr.success("Contact HR status updated successfully.");
                        })
                        .fail(function () {
                            toastr.error("Failed to update Contact HR status. Please try again.");
                        });
                });
            }
        };

        return contact;
    }()
);